import { format } from 'd3-latest';
export const formatValuation = (s, digits = 0) =>
	typeof s === 'number' ? format(`.${digits}s`)(s).replace(/G/, 'B') : 'Coming soon';
